'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _FileModel = require('../model/FileModel');

var _FileModel2 = _interopRequireDefault(_FileModel);

var _ImageSelectControl = require('../../../lib/ui/ImageSelectControl');

var _ImageSelectControl2 = _interopRequireDefault(_ImageSelectControl);

var _TextControl = require('../../../lib/ui/TextControl');

var _TextControl2 = _interopRequireDefault(_TextControl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FileForm = function () {
  function FileForm(element, args) {
    _classCallCheck(this, FileForm);

    var fieldsetFile = document.createElement('fieldset');
    var legendFile = document.createElement('legend');
    legendFile.innerHTML = 'Bestandsgegevens';
    fieldsetFile.appendChild(legendFile);

    this.id = new _TextControl2.default(fieldsetFile, { label: 'Id', value: args.file.values.id, onchange: args.onchange });
    this.contents = new _TextControl2.default(fieldsetFile, { label: 'Inhoud', value: args.file.values.contents, onchange: args.onchange });

    var fragment = document.createDocumentFragment();
    fragment.appendChild(fieldsetFile);
    element.appendChild(fragment);
  }

  _createClass(FileForm, [{
    key: 'getValue',
    value: function getValue() {
      var file = new _FileModel2.default();
      file.values.id = this.id.getValue();
      file.values.contents = this.contents.getValue();
      return file;
    }
  }, {
    key: 'setValue',
    value: function setValue(file) {
      this.id.setValue(file.values.id);
      this.contents.setValue(file.values.contents);
    }
  }]);

  return FileForm;
}();

exports.default = FileForm;


//////////////////
// WEBPACK FOOTER
// ./js/modules/file/ui/FileForm.js
// module id = 73
// module chunks = 0